/*
 * Shared formatting helpers reused across pages/components.
 * Pure functions — no React, safe to import anywhere.
 */

// Long date, e.g. "5 January 2026" (blog post dates). Empty string when absent.
export function formatDate(d) {
  if (!d) return '';
  return new Date(d).toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' });
}

// Short date, e.g. "5 Jan 2026" (admin lists). Em dash when absent.
export function formatShortDate(d) {
  return d ? new Date(d).toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' }) : '—';
}

// Short date + time, e.g. "5 Jan 2026, 09:30 pm" (admin tables). Em dash when absent.
export function formatDateTime(d) {
  return d ? new Date(d).toLocaleString('en-IN', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—';
}

// Number with fixed decimals and Indian grouping, e.g. "1,23,456.00". Em dash for null/NaN.
export function formatNumber(n, decimals = 2) {
  if (n == null || isNaN(n)) return '—';
  return Number(n).toLocaleString('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}

// Rupee currency, e.g. "₹1,23,456.00". Em dash for null/NaN.
export function formatCurrency(n) {
  if (n == null || isNaN(n)) return '—';
  return '₹' + formatNumber(n);
}
